import React from 'react';
import { Flex, Spinner, Text } from '@zillow/constellation';
import DataCard from 'app/shared/components/DataCard';
import AutocompleteAreaInput from 'app/shared/components/AutocompleteAreaInput';
import type AutocompleteArea from 'app/shared/models/AutocompleteArea';

interface SearchMarketsProps {
  submit: (area: AutocompleteArea) => void;
  isLoading: boolean;
  error: string | null;
}

const SearchMarkets: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<SearchMarketsProps>>> = (
  props,
) => {
  const { submit, isLoading, error } = props;
  return (
    <DataCard
      heading="Stay on top of market trends in your area"
      copyText="Understand median rent prices, compare markets, and renter expectations in the market."
      useFullScreen={true}
      marginTop="md"
    >
      <Text as="p" fontType="bodyHeading" marginBottom="xs">
        Enter a market to explore trends
      </Text>
      <Flex display="flex">
        <AutocompleteAreaInput submit={submit} error={error} />
        {isLoading && <Spinner size="md" marginLeft="xs" />}
      </Flex>
    </DataCard>
  );
};

export default SearchMarkets;
